import { useQueryClient } from '@tanstack/react-query'

import api from 'src/constants/api'

import useAccount from 'src/hooks/utils/useAccount'
import useMutation from 'src/hooks/utils/useMutation'

const useDeleteApplicationSecretMutation = (appId: string) => {
  const account = useAccount()
  const queryClient = useQueryClient()

  return useMutation(
    async (keyId: string) => {
      const response = await api.delete(`graph/account/${account.id}/application/${appId}/secrets/${keyId}`)
      return response.data
    },
    {
      onSuccess: (_, keyId) => {
        // Optimistically update the applications query cache to remove the deleted secret
        queryClient.setQueryData(['applications', account.id], (oldData: any) => {
          if (!oldData) return oldData

          return oldData.map((app: any) => {
            if (app.appId === appId) {
              return {
                ...app,
                passwordCredentials: (app.passwordCredentials || []).filter((cred: any) => cred.keyId !== keyId)
              }
            }
            return app
          })
        })
      },
      successMessage: 'Secret deleted successfully.',
      errorMessage: 'We were unable to delete the secret. If the problem persists, please contact support.'
    }
  )
}

export default useDeleteApplicationSecretMutation
